// src/util/Simulate.js

import MiscValue from "../value/MiscValue";

/*
const rulLooksLike = {

    minimalTradeTimes: DefaultRule.minimalTradeTimes.default,
    buyInterval: DefaultRule.buyInterval.default,
    buyAmount: DefaultRule.buyAmount.default,
    bullIntervalFactor: DefaultRule.bullIntervalFactor.default,
    bearIntervalFactor: DefaultRule.bearIntervalFactor.default,
    avgDownFactorMax: DefaultRule.avgDownFactorMax.default,
    acceptableChange: DefaultRule.acceptableChange.default,
    exitOnProfit: DefaultRule.exitOnProfit.default,
    exitOnProfitDrop: DefaultRule.exitOnProfitDrop.default,
    partialSellOnProfit: DefaultRule.partialSellOnProfit.default,
    partialSellThreshold: DefaultRule.partialSellThreshold.default,
    suddenDropBuyThreshold: DefaultRule.suddenDropBuyThreshold.default,
    suddenDropBuyFactor: DefaultRule.suddenDropBuyFactor.default,
    rollingHighPeriod: DefaultRule.rollingHighPeriod.default
    startDate,
    endDate,
}
*/

export default class Simulate {
    indexStartDate = 0;
    indexEndDate = 0;

    lastDeal = {};
    records = []; // 거래 기록

    summary = {
        price: 0,
        count: 0,
        amount: 0,
        profit: 0,
        amountBought: 0, // 총 매수 금액
        amountSold: 0, // 총 매도 금액
        deposit: 0, // 예수금.
        moneyAdded: 0, // 추가 입금.
        profitPercent: 0.0, // 수익률.
        closePriceFirstDay: 0, // 첫날 종가.
        closePriceLastDay: 0, // 마지막 날 종가.
        lastDate: '', // 최종 매도한 날짜.
        indexStartDate: 0,
        indexEndDate: 0
    };

    constructor(rule, stockOriginal) {
        this.rule = rule;
        this.stockData = []; // stockData;

        // 롤링 최고가 계산
        stockOriginal.forEach((rec, index) => {
            const data = {...rec};
            data.index = index;

            if (data.date === rule.startDate) {
                this.indexStartDate = index;
                this.summary.indexStartDate = index;
            }
            if (data.date === rule.endDate) {
                this.indexEndDate = index;
                this.summary.indexEndDate = index;
            }

            if(rule.rollingHighPeriod > 1) {
                if(index >= rule.rollingHighPeriod - 1) {
                    // close 가격의 롤링 최고가를 계산
                    let minIndex = index - rule.rollingHighPeriod + 1;
                    let rollingHigh = 0;
                    for(let k=minIndex; k<= index; k++) {
                        const prevData = stockOriginal[k];
                        if(prevData.close > rollingHigh) rollingHigh = prevData.close;
                    }
                    data.rollingHigh = rollingHigh;
                }
            }
            this.stockData.push(data);
        });
    }

    midPrice = (rec) => Math.floor((rec.open + rec.close) / 2);

    /*
    평균단가 구하기 도상시험:
        buy 10  1000    10,000 / 10 = 1000
        buy 10  1200    22,000 / 20 = 1100
        buy 10  1000    32,000 / 30 = 1066.67
        sell 10 1500    매도하면 평균단가는 변하지 않음. 숫자만 20으로 줄어들고 평균단가는 1066.67 총액은 32,000 - 15,000 = 17,000
        buy 10  1100

        # 매도시 보유총액 계산의 주의점: 이미 가지고있던 총액에서 동일한 평균단가의 일정갯수 주식을 매도하는 것이므로 매도가격과는 무관함.
        # ... 매도가격은 수익이나 손실을 결정짓는 것이지 보유총액을 결정짓는 것이 아님.
        # 보유총액부터 계산해야 함 보유총액 구글sheet 함수 =if(거래주식수<0, (현재보유주식수/이전보유주식수)*이전보유총액, 이전보유총액+매수총액)
        # 평균단가 구글 sheet 함수 =if(거래주식수<0,이전평균단가,현재보유총액/현재보유주식수)
        # 수익계산 구글 sheet 함수 =if(거래주식수<0,(현재단가-이전평균단가)*-거래주식수,0)
    */

    makeSummary = () => {
        if(this.records.length === 0) {
            return;
        }
        let amountBought = 0; // 실제로 매수한 금액.
        let amountSold = 0;   // 실제로 매도한 금액.
        let count = 0, amount = 0; // (보유주식수, 보유총액)
        let prevAverage = 0; // 이전평균단가.
        let profitSum = 0;

        this.records.forEach(record => {

            if(record.count > 0) {
                amountBought += record.amount; // 매수한 금액만 합산
                amount += record.amount;
                record.priceAverage = amount / (record.count + count); // 현재보유총액 / 현재보유주식수
            } else {
                amountSold += -record.amount; // 매도한 금액만 합산
                amount = amount * (count + record.count) / count; // (현재보유주식수/이전보유주식수)*이전보유총액
                record.priceAverage = prevAverage;
                let profit = (record.price - prevAverage) * -record.count;
                profitSum += profit;
                record.profit = profit;
            }

            count += record.count;
            prevAverage = record.priceAverage;
            record.sum = count;
        });

        this.summary.amountBought = amountBought;
        this.summary.amountSold = amountSold;
        
        this.summary.profit = profitSum;

        if(count === 0) {
            this.summary.price = 0;
            this.summary.count = 0;
            this.summary.amount = amount;
            return;
        }

        // 문제점: 매도했을 때는 평균단가가 달라지면 안되는데, 지금 계산방식은 매도 후에 평균단가가 달라진다.

        this.summary.price = amount / count;
        this.summary.count = count;
        this.summary.amount = amount;
        console.log("Summary.count=", this.summary.count);
        // this.records[this.records.length-1].priceAverage = this.summary.price.toFixed(2);
    };

    buy = (record, index, buyAmount) => {
        const midPrice = this.midPrice(record);
        const count = Math.round(buyAmount / midPrice);

        if(count > record.volume / 10) {
            return null; //  매수할 수 있는 주식 수가 너무 적음
        }
        const boughtAmount = count * midPrice;

        if(boughtAmount > this.summary.deposit) {
            const diff = boughtAmount - Math.floor(this.summary.deposit);
            this.summary.moneyAdded += diff; // 추가 입금.
            this.summary.deposit += diff; // 예수금에도 추가.
        }

        this.summary.deposit -= boughtAmount; // 예수금에서 차감.

        const deal = {
            date: record.date,
            index: index,
            price: midPrice,
            close: record.close,
            amount: boughtAmount,
            count: count
        };

        console.log(`Buying ${count} shares at ${midPrice} on ${record.date}.`, deal);

        this.records.push(deal);
        // this.lastDeal = deal; sudden-drop buy 때문에 밖에서 컨트롤.

        this.makeSummary();

        return deal;
    };

    sell = (record, index, count) => {
        const price = this.midPrice(record);
        if(count > this.summary.count) {
            count = this.summary.count; // 매도할 주식 수가 보유 주식 수보다 많으면 보유 주식 수로 조정
        }

        this.summary.deposit += count * price; // 예수금에 추가

        console.log(`Selling ${count} shares at ${price} on ${record.date}.`);

        const deal = {
            date: record.date,
            index: index,
            price: price,
            close: record.close,
            amount: -count * price,
            count: -count
        };

        this.records.push(deal);
        this.lastDeal = deal;

        this.makeSummary();

        return deal;
    };

    run = () => {

        if(this.indexEndDate - this.indexStartDate < this.rule.buyInterval * this.rule.minimalTradeTimes) {
            console.log("Not enough trading days.");
            this.summary.error = `최소 거래일 수 ${this.rule.minimalTradeTimes}일과 매수 간격 ${this.rule.buyInterval}일을 곱한 값보다 총 거래 기간이 짧습니다.`;
            return { result: this.records, summary: this.summary };
        }

        const bullInterval = Math.round(this.rule.buyInterval * this.rule.bullIntervalFactor);
        const bearInterval = Math.round(this.rule.buyInterval * this.rule.bearIntervalFactor);
        const minInterval = Math.min(bullInterval, bearInterval);

        let idx = this.indexStartDate;
        // 첫 매수
        let theDeal = this.buy(this.stockData[idx], idx, this.rule.buyAmount);
        if(theDeal) {
            this.lastDeal = theDeal;
            this.summary.closePriceFirstDay = this.stockData[idx].close; // 첫날 종가 저장
        }
        else {
            this.summary.error = `첫 매수(${MiscValue.formatFloat(this.rule.buyAmount)})에 실패했습니다.`;
            return { result: this.records, summary: this.summary };
        }

        let suddenDropBuyIndex = 0; //  급락매수를 한 경우 최종 급락 매수일의 인덱스
        let safeCount = 0;
        let safeLimit = this.indexEndDate - this.indexStartDate;
        //let lastPeak = 0; // exitOnProfit 이후 마지막 고점. 이 고점 대비 현재가가 3% 이상 떨어지면 모두 팔기.
        while(idx < this.indexEndDate) {

            if(safeCount >= safeLimit) {
                console.log(`Safe limit reached on ${this.stockData[idx].date}.`);
                this.summary.error = `프로그램에 오류가 있습니다. (${safeCount} >= ${safeLimit})`;
                break;
            }
            safeCount++;
            const rec = this.stockData[idx];
            const profitRate = rec.open / this.summary.price - 1;

            // 매도 먼저 확인. 매도할 때에는 매수 인터벌은 적용하지 않음. 수익률이 유일한 기준.
            if(this.records.length > this.rule.minimalTradeTimes) {
                // 모두 팔아야 할지 확인.
                /* if(lastPeak > 0) {
                    const thisPeak = rec.close > rec.open ? rec.close : rec.open;
                    if(thisPeak > lastPeak) lastPeak = thisPeak;
                    else {
                        // 모두 팔 것인가?
                        const mp = this.midPrice(rec);
                        if(mp <= lastPeak * (1-this.rule.exitOnProfitDrop)) {
                            break; // 모두 팔기 (저어어어기 아래에서 팔게 되어 있음.)
                        }
                    }
                }
                else { */
                    if(profitRate >= this.rule.exitOnProfit) {
                        console.log(`Selling all shares on ${rec.date} happily.`);
                        // lastPeak = rec.close > rec.open ? rec.close : rec.open; // 마지막 고점 초기화.
                        break; // 저 아래에서 모두 팔기
                        //idx++;
                        //continue;
                    }
                    // 부분 매도 확인.
                    if(
                        profitRate >= this.rule.partialSellOnProfit
                        && this.rule.partialSellThreshold > 0
                        && this.rule.partialSellOnProfit > 0
                    )
                    {
                        if(this.summary.count === 1) {
                            // 그럼 그냥 다 팔아버려야지.
                            break; // 저 아래에서 모두 팔기
                        }
                        // 그렇지 않으면 부분 매도.
                        let sellCount = Math.floor(this.summary.count * this.rule.partialSellThreshold);
                        
                        if(sellCount < 1) sellCount = 1; // 최소 1주 이상 팔아야 함.

                        this.sell(rec, idx, sellCount);
                        // 부분 매도 후 매수하지 않음.
                        idx++;
                        continue;
                    }
                //}
            }

            //console.log(`const interval = idx ${idx} - this.lastDeal.index ${this.lastDeal.index}; // 마지막 매수 이후 경과 일수`);
            const interval = idx - this.lastDeal.index; // 마지막 매수 이후 경과 일수
            let amountToBuy;

            if(interval >= minInterval) {
                let buyToday = false; // 오늘 매수 여부

                if(rec.open > Math.round(this.lastDeal.price * (1 + this.rule.acceptableChange))) {
                    // 주가가 일상범위 넘어 오르고 있다.
                    if(bullInterval >= interval) buyToday = true;
                    // 그렇지 않으면 다음날로 넘어가게 된다.
                }
                else if(rec.open < Math.round(this.lastDeal.price * (1 - this.rule.acceptableChange))) {
                    if(interval >= bearInterval) buyToday = true;
                    // 그렇지 않으면 다음날로 넘어가게 된다.
                }
                else {
                    console.log(`Check if interval ${interval} >= buyInterval ${this.rule.buyInterval}`);
                    // 주가가 허용 범위 내에 있다면 정기적으로 매수한다.
                    if(interval >= this.rule.buyInterval) buyToday = true;
                    // 그렇지 않으면 다음날로 넘어가게 된다.
                }

                if(buyToday) {
                    if(profitRate < 0 && this.rule.avgDownFactorMax > 1) {
                        amountToBuy = Math.round(this.rule.buyAmount * (1 + (this.rule.avgDownFactorMax - 1) * -profitRate));
                    }
                    else {
                        amountToBuy = this.rule.buyAmount;
                    }
                    
                    const theDeal = this.buy(rec, idx, amountToBuy);
                    if(theDeal) {
                        this.lastDeal = theDeal;
                    }
                }
            }
            else {
                // 급락 확인 및 추가 매수.
                if(this.rule.suddenDropBuyIndex > 0 && rec.rollingHigh > 0
                    && rec.open < (rec.rollingHigh * (1 - this.rule.suddenDropBuyThreshold))
                    && idx - suddenDropBuyIndex >= this.rule.rollingHighPeriod
                ) {
                    // 롤링 최고가 대비 급락한 경우
                    const amountToBuy = Math.floor(this.rule.buyAmount * this.rule.suddenDropBuyFactor);
                    const theDeal = this.buy(rec, idx, amountToBuy);
                    if(theDeal) {
                        // this.lastDeal = theDeal; - 넣지 않는다. 대신...
                        suddenDropBuyIndex = idx;
                    }
                }
            }

            idx++; // 다음날로 넘어간다.
        } // end of while

        console.log(`@@@@ Loop count ${safeCount}`);

        // 마지막에는 모두 팔기
        if(this.summary.count > 0) {
            // 마지막 처리에서 $idx 대신 $indexEndDate를 강제하면 안돼. 왜나하면, 수익률이 충분하면 그 이전에라도 전액 매도해야만 하니까.
            const rec = this.stockData[idx];
            console.log(`#### Selling all remaining shares on ${rec.date}.`);
            this.sell(rec, idx, this.summary.count);
            this.summary.closePriceLastDay = rec.close; // 마지막 날 종가 저장
            this.summary.lastDate = rec.date; // 최종 매도한 날짜 저장
            this.summary.indexEndDate = idx; // 마지막 매도일 인덱스 수정.
        }
        // my $profitPercent = 100 * $summary->{profit} / $summary->{moneyAdded};
        console.log(`Money added: ${this.summary.moneyAdded}. profit = ${this.summary.profit}`);
        if(this.summary.moneyAdded > 0) {
            const profitPercent = 100 * this.summary.profit / this.summary.moneyAdded;
            this.summary.profitPercent = profitPercent;
        }

        // 최종 결과 출력.

        return { result: this.records, summary: this.summary };
    }
}
